document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortBy', (sectionId, filterType, isSearchPage, isExpanded) => ({
    t: '',
    isShow: false,
    showFilterAside: true,
    isLoading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: {},
    additionalSearchParams: "",
    sortOption: "",
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    rwadyCollectionSearchController: null,
    init() {
      if (localStorage.getItem(`${FACET.productLayout}`) == 'list') {
        this.listLayout = true;
      }
      Alpine.nextTick(() => {
        this._initLayout();
      })
      this._connectRwadyCollectionSearch();
      document.addEventListener('rwady:collection-search-controller-ready', () => {
        this._connectRwadyCollectionSearch();
      }, { once: true });
      this._setListeners();

      installMediaQueryWatcher("(min-width: 768px)", (matches) => {
        if (matches) {
          if (filterType != 'drawer') {
            this.isShow = false;
            Alpine.store("xMaximizeDrawer").handleClose();
          }
          this.isDesktop = true;
        } else {
          this.isDesktop = false;
        }
      });

      if (isSearchPage) {
        this.isSearchPage = isSearchPage
        this.additionalSearchParams = "type=product";
      }
    },
    _connectRwadyCollectionSearch() {
      if (isSearchPage) return false;
      const controller = window.RwadyCollectionSearchController;
      if (!controller?.claims?.(this.$el)) return false;
      this.rwadyCollectionSearchController = controller;
      controller.attachFacets(this, sectionId);
      return true;
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0] || null;
      let formDrawer = document.getElementsByClassName('form-drawer')[0] || null;
      if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
        this.isDesktop = true;
        if (formAside) {
          if (formAside.id !== 'FacetFiltersForm') formAside.id = 'FacetFiltersForm';
          if (formDrawer?.id) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer && formDrawer.id !== 'FacetFiltersForm') formDrawer.id = 'FacetFiltersForm';
        }
      } else {
        this.isDesktop = false;
        if (formAside?.id) formAside.removeAttribute('id');
        if (formDrawer && formDrawer.id !== 'FacetFiltersForm') formDrawer.id = 'FacetFiltersForm';
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        if (window.RwadyCollectionSearchController?.claims?.(this.$el)) return;
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);

      document.addEventListener(SELECT_ELEMENT_EVENT.change, (event) => {
        let sortByOption = event.target;
        if (sortByOption.classList.contains('sorting-option'))
          this.onSubmit(0);
      });
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem(`${FACET.productLayout}`, theBoolean ? "list" : "grid" );
      // delay resize event run after repaint
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('resize', { detail: { isChangeLayoutMode: true } }));
      }, 300)
    },
    removeFilter(url) {
      const controller = this.rwadyCollectionSearchController || (this._connectRwadyCollectionSearch() && this.rwadyCollectionSearchController);
      if (controller) {
        controller.handleFilterURL(url);
        return;
      }
      let removeUrl = url
      if (this.isSearchPage) {
        removeUrl = `${url}&${this.additionalSearchParams}`
      }
      this._reloadFilter(removeUrl);
    },
    onSubmit(wait = 500) {
      if (this.t) {
        clearTimeout(this.t);
      }

      const func = () => {
        const facetForm = document.getElementById('FacetFiltersForm');
        const controller = this.rwadyCollectionSearchController || (this._connectRwadyCollectionSearch() && this.rwadyCollectionSearchController);
        if (controller && facetForm) {
          controller.handleFacetSubmit(facetForm);
          if (this.isDesktop) {
            document.getElementById('SelectSortByOption')?.blur();
          }
          return;
        }
        const searchParams = this._createSearchParams(facetForm);
        this._renderPage(searchParams);
        if (this.isDesktop) {
          document.getElementById('SelectSortByOption').blur();
        }
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },

    _reloadFilter(url) {
      const controller = this.rwadyCollectionSearchController || (this._connectRwadyCollectionSearch() && this.rwadyCollectionSearchController);
      if (controller) {
        controller.handleFilterURL(url);
        return;
      }
      const searchParams = new URLSearchParams(url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1));
      const originalQuery = new URLSearchParams(window.location.search).get('rwady_q');
      if (originalQuery !== null) searchParams.set('rwady_q', originalQuery);
      this._renderPage(searchParams.toString());
    },
    _getRwadyInlineSearchContext() {
      const scope = document.querySelector('[data-rwady-collection-search-scope][data-rwady-search-within-collection="false"]');
      const state = window.RwadyNativeCollectionSearchState;
      if (!scope || !state?.showingAllProducts) return null;

      const input = scope.closest('.rwady-mobile-search')?.querySelector('[data-rwady-search-input]');
      const query = input?.value || scope.dataset.rwadySearchQuery || '';
      if (!query.trim()) return null;

      const normalizedQuery = window.RwadySearchNormalization?.createRwadySearchParams(query)?.q || query;
      return { scope, state, query, normalizedQuery };
    },
    _createSearchParams(form) {
      if (form) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData);
        const desktopSort = form.querySelector('.rwady-desktop-sort-filter__select');
        if (desktopSort && window.innerWidth >= 1024) {
          searchParams.set('sort_by', desktopSort.value);
        }
        const originalQuery = new URLSearchParams(window.location.search).get('rwady_q');
        if (originalQuery !== null) searchParams.set('rwady_q', originalQuery);
        const inlineSearch = this._getRwadyInlineSearchContext();
        if (inlineSearch) {
          searchParams.set('q', inlineSearch.normalizedQuery);
          searchParams.set('type', 'product');
          searchParams.set('options[prefix]', 'last');
          searchParams.set('rwady_q', inlineSearch.query);
        }
        return searchParams.toString();
      }
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    async _renderPage(searchParams, updateURLHash = true) {
      if (updateURLHash) {
        const params = new URLSearchParams(searchParams);
        const view = new URLSearchParams(window.location.search).get('view');
        if (!params.has('view') && view) params.set('view', view);
        if (this._getRwadyInlineSearchContext()) {
          const pageView = document.querySelector('#ProductGridContainer .rwady-page-controls')?.dataset.pageView;
          const size = (pageView || view || '').match(/(?:rwady-|irons-)(25|50|75|100)$/)?.[1] || '25';
          params.set('view', 'rwady-' + size);
        }
        searchParams = params.toString();
      }
      this.searchParamsPrev = searchParams;
      this.isLoading = true;
      const inlineSearch = this._getRwadyInlineSearchContext();
      const root = window.Shopify?.routes?.root || '/';
      const requestUrl = inlineSearch
        ? `${root}search?${searchParams}`
        : `${window.location.pathname}?section_id=${sectionId}&${this.additionalSearchParams}&${searchParams}`;
      const cacheKey = `${inlineSearch ? 'rwady-inline-search' : window.location.pathname}:${searchParams}`;

      if (this.cachedResults[cacheKey]) {
        this._renderResults(this.cachedResults[cacheKey], inlineSearch);
        if (updateURLHash && !inlineSearch) {
          this._updateURLHash(searchParams);
        }
        return;
      }

      try {
        const response = await fetch(requestUrl, { headers: { Accept: 'text/html' } });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const html = await response.text();
        this.cachedResults[cacheKey] = html;
        this._renderResults(html, inlineSearch);
      } catch (error) {
        console.error("Failed to fetch page:", error);
      }

      if (updateURLHash && !inlineSearch) {
        this._updateURLHash(searchParams);
      }
    },
    _renderResults(html, inlineSearch = null) {
      if (!inlineSearch) this._renderFilters(html);
      this._renderProductGridContainer(html, inlineSearch);
      this._renderProductCount(html);
      if (inlineSearch) {
        inlineSearch.state.showingAllProducts = true;
        inlineSearch.state.globalSearchParams = this.searchParamsPrev;
      }
      if (this.isSearchPage) {
        this.__renderProductTabButton(html)
      }
      this.isLoading = false;
    },
    renderRwadyCollectionSearchResults(html, isSearchSource = false) {
      this._renderFilters(html);
      this._renderProductGridContainer(html, isSearchSource ? { source: 'search' } : null);
      this._renderProductCount(html);
      this._initLayout();
      this.isLoading = false;
      this.releaseFilterDrawerLock();
    },
    __renderProductTabButton(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').querySelector('.button-tab-product');
      if (productCountEl) {
        const containerDrawer = document.querySelector('.button-tab-product');
        if (containerDrawer) containerDrawer.innerHTML = productCountEl.innerHTML;
      }
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let blockFilterDrawer = '.form-drawer';
      let blockFilterAside = '.form-aside';
      const selectblockFilterDrawer = document.querySelector(blockFilterDrawer);
      const selectblockFilterAside = document.querySelector(blockFilterAside);
      const filterWrapper = document.querySelector(".facet-filter-wrapper");
      const filterWrapperToRender = parsedHTML.querySelector(".facet-filter-wrapper")
      const buttonFilterWrapper = document.getElementById('ButtonFilterWrapper');
      if (parsedHTML.querySelector(".js-filter")) {
        filterWrapper.style.display = "";
        if (buttonFilterWrapper) {
          buttonFilterWrapper.style.display = "";
        }
        if (selectblockFilterDrawer) {
          if (this.$el.id) {
            const blockFilterDrawerElement = parsedHTML.querySelector(blockFilterDrawer);
            if (blockFilterDrawerElement) {
              blockFilterDrawerElement.querySelectorAll('.js-filter').forEach((element, index) => {
                const filterParam = element.dataset.paramName;
                let currentElement = selectblockFilterDrawer.querySelector(`[data-param-name="${filterParam}"]`);
                if (currentElement) {
                  const isExpanded = currentElement.isOpen === true 
                    || currentElement.dataset.expanded === 'true';
                  element.setAttribute('data-expanded', isExpanded ? 'true' : 'false');
                }
              });
            }
          }

          const newblockFilterDrawer = parsedHTML.querySelector(blockFilterDrawer);
          if (newblockFilterDrawer) {
            selectblockFilterDrawer.innerHTML = newblockFilterDrawer.innerHTML;
          } else {
            selectblockFilterDrawer.innerHTML = '';
          }
          this._renderAdditionalElements(parsedHTML);
        };
        if (selectblockFilterAside) {
          if (this.$el.id) {
            const blockFilterAsideElement = parsedHTML.querySelector(blockFilterAside);
            if (blockFilterAsideElement) {
              blockFilterAsideElement.querySelectorAll('.js-filter').forEach((element, index) => {
                let isExpanded = '{open: false}';
                const filterParam = element.dataset.paramName;
                let currentElement = selectblockFilterAside.querySelector(`[data-param-name="${filterParam}"]`);
                if (currentElement) {
                  isExpanded = currentElement.dataset.expanded == 'true' ? '{open: true}' : '{open: false}';
                }
                element.setAttribute('x-data', isExpanded);
              });
            }
          }

          const newblockFilterAside = parsedHTML.querySelector(blockFilterAside);
          if (newblockFilterAside) {
            selectblockFilterAside.innerHTML = newblockFilterAside.innerHTML;
          } else {
            selectblockFilterAside.innerHTML = ""
          }
    
          this._renderAdditionalElements(parsedHTML);
        };
        
        const filterTagEl = document.getElementById('ActiveFilterTag');
        const renderedFilterBar = parsedHTML.getElementById('FacetsContainerBar')?.content;
        const newFilterTagEl = renderedFilterBar?.getElementById('ActiveFilterTag');

        if (filterTagEl) {
          if (newFilterTagEl) {
            filterTagEl.innerHTML = newFilterTagEl.innerHTML;
          } else {
            filterTagEl.innerHTML = "";
          }
        }
        const filterWrapperBar = document.getElementById("FacetsWrapperBar");
        const renderedFilterWrapperBar = renderedFilterBar?.getElementById('FacetsWrapperBar');
        const activeFilterCount = renderedFilterWrapperBar?.dataset.activeFilterCount ?? '0';
        const activeFilterCountElement = document.getElementById('FilterActiveCount');
        if (activeFilterCountElement) {
          activeFilterCountElement.textContent = ` (${activeFilterCount})`;
          activeFilterCountElement.hidden = Number(activeFilterCount) === 0;
        }
        if (filterWrapperBar?.dataset.stickyFilter === "true") {
          this.setFilterHeaderHeight();
        }
      } else {
        if (filterWrapperToRender?.dataset.showFilter === "false") {
          filterWrapper.classList.add("md:hidden");
          filterWrapper.innerHTML = filterWrapperToRender.innerHTML;
          this._initLayout();
        }
        if (!parsedHTML.querySelector('.facets-filter__wrapper')?.dataset.enableFilter && buttonFilterWrapper) {
          buttonFilterWrapper.style.display = "none"
        }
        if (filterType == 'drawer') {
          document.body.classList.remove('overflow-y-hidden');
        }
      }
      
      this._renderAdvancedFilters(parsedHTML, "desktop");
      this._renderAdvancedFilters(parsedHTML, "mobile");
      const mobileActiveFilterTag = document.getElementById("mobile-active-filter-tag");
      const renderedMobileFilterTag = parsedHTML.querySelector("#mobile-active-filter-tag");
      if (mobileActiveFilterTag && renderedMobileFilterTag) {
        mobileActiveFilterTag.innerHTML = renderedMobileFilterTag.innerHTML
      }
    },
    _renderAdvancedFilters(html, type) {
      const destination = document.querySelectorAll( `.${type}-advanced-filter`);
      const source = html.querySelectorAll(`.${type}-advanced-filter`);

      if (destination.length > 0) {
        destination.forEach((destination, index) => {
          if (source[index]) {
            destination.innerHTML = source[index].innerHTML;
          } else {
            destination.innerHTML = "";
          }
        })
      }
    },
    _renderProductGridContainer(html, inlineSearch = null) {
      const productGridContainer = document.getElementById('ProductGridContainer');
      const destinationElement = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer')
      
      if (productGridContainer && destinationElement) {
        productGridContainer.innerHTML = destinationElement.innerHTML;
        if (inlineSearch) {
          const injectedGrid = productGridContainer.querySelector('[id^="ItemsGrid-"]');
          if (injectedGrid) injectedGrid.id = 'ItemsGrid';
        }
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
      }
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetsProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        const containerMobile = document.getElementById('ProductCountMobile');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
        if (containerMobile) containerMobile.innerHTML = count;
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      const destinationElement = html.getElementById('ProductPerPage')
      if (container && destinationElement) container.innerHTML = destinationElement.innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('FacetsFilterDrawer','CloseFilterDrawer');
    },
    _filterRemoveFocus() {
      Alpine.store('xFocusElement').removeTrapFocus();
    },
    ownsFilterDrawerLock() {
      const drawerStore = Alpine.store('xMaximizeDrawer');
      const currentDrawer = document.getElementById('FacetsFilterDrawer');
      return this.isShow
        || currentDrawer?.classList.contains('is-open')
        || drawerStore?.activeDrawerElement?.id === 'FacetsFilterDrawer'
        || drawerStore?.drawerCloseElement?.id === 'FacetsFilterDrawer';
    },
    releaseFilterDrawerLock() {
      if (!this.ownsFilterDrawerLock()) return false;

      this._filterRemoveFocus();
      this.isShow = false;
      const drawerStore = Alpine.store('xMaximizeDrawer');
      const currentDrawer = document.getElementById('FacetsFilterDrawer');
      currentDrawer?.classList.remove('is-open');

      if (drawerStore?.activeDrawerElement?.id === 'FacetsFilterDrawer') {
        drawerStore.activeDrawerElement = false;
      }
      if (drawerStore?.drawerCloseElement?.id === 'FacetsFilterDrawer') {
        drawerStore.drawerCloseElement = false;
      }
      if (drawerStore && !drawerStore.activeDrawerElement) drawerStore.isOpen = false;

      const hasOtherOpenDrawer = document.querySelector('.drawer__wrapper.is-open:not(#FacetsFilterDrawer)');
      if (!hasOtherOpenDrawer) document.body.classList.remove('overflow-y-hidden');
      return true;
    },
    closeFilterDrawer() {
      this.releaseFilterDrawerLock();
    },
    setFilterHeaderHeight() {
      const filterWrapperBar = document.getElementById("FacetsWrapperBar");
      if (!filterWrapperBar) return;
      const height = filterWrapperBar.getBoundingClientRect().height + "px";
      const style = document.documentElement.style;
      if (style.getPropertyValue('--height-sticky-filter') !== height) {
        style.setProperty('--height-sticky-filter', height);
      }
    },
    setPositionOptionFilter(el) {
      let elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    }
  }));
});

